export default {
  sendEvent(apiName, options) {
    if (typeof window.intellimize === 'undefined') return;

    window.intellimize.ready(() => {
      window.intellimize.sendEvent(apiName, options);
    });
  },
};
